import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';

const DEFAULT_QUERY_PARAMS = {
    buyNow: false,
    keyword: '',
    page: 1,
    pageSize: 24,
    sort: SearchSortAndDirection.LotNumberLowest,
};

const normalizeQuery = (query: any = {}, defaults: any = DEFAULT_QUERY_PARAMS) => {
    const newQuery = { ...query };
    Object.keys(query).forEach((prop) => {
        if (defaults[prop] === undefined || defaults[prop] === 'NaN') {
            delete newQuery[prop];
        } else if (typeof defaults[prop] === 'number' && query[prop] !== 'all') {
            newQuery[prop] = Number(query[prop]);
        }
    });
    return newQuery;
};

export default normalizeQuery;
